import { Text } from "@/components/ui/text";
import ModalBase from "./ModalBase";
import i18n from "i18n-js";

export default function EditWorkflowModal({ showModal, setShowModal, workflowTitle }) {

    const onClose = (isOk) => {
        setShowModal(isOk)
    }

    return (
        <ModalBase showModal={showModal} setShowModal={onClose} title={'studio.flow.importHello'} onButton={onClose} buttonR={'studio.flow.convertToStudioWorkflow'} buttonL={'studio.flow.watch'}>
            <Text className="text-xl text-secondary-900">{i18n.t('studio.flow.importMessage', { title: workflowTitle })}</Text>
        </ModalBase>
    );
}
